export enum CelestialType {

    BlackHole = 0,

}
